var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("vue-confirm-dialog"),
      _vm.authenticated
        ? [
            _c(
              "div",
              {
                staticClass:
                  "h-screen flex overflow-hidden bg-secondary-background",
              },
              [
                _vm.isResourcesOboarded
                  ? _c("ExtendedSidebar", {
                      attrs: {
                        sidebarOpened: _vm.sidebarOpen,
                        currentUser: _vm.currentUser,
                        company: _vm.company,
                      },
                      on: { closeSidebar: _vm.closeSidebar },
                    })
                  : _vm._e(),
                _vm.sidebarOpen
                  ? _c("div", {
                      staticClass:
                        "top-0 left-0 w-screen h-screen absolute z-10 bg-black opacity-50 lg:hidden",
                      on: { click: _vm.closeSidebar },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "flex flex-col w-0 flex-1 sm:mb-4" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-row justify-between hidden sm:flex mb-2 hidden-print header-container",
                      },
                      [
                        _c("Breadcrumbs", {
                          class: [
                            _vm.containerClasses,
                            // { 'custom-breadcrumbs-title': isManagersPage || isResourcesPage || isProjectPage},
                            // { 'custom-breadcrumbs-title':},
                          ],
                          attrs: { currentUser: _vm.currentUser },
                        }),
                        _vm.currentUser
                          ? _c("Navbar", {
                              attrs: {
                                sidebarOpen: _vm.sidebarOpen,
                                currentUser: _vm.currentUser,
                                auth: _vm.authenticated,
                                company: _vm.company,
                              },
                              on: { openSidebar: _vm.openSidebar },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col justify-between sm:hidden mb-2 hidden-print header-container",
                      },
                      [
                        _vm.currentUser
                          ? _c("Navbar", {
                              attrs: {
                                sidebarOpen: _vm.sidebarOpen,
                                currentUser: _vm.currentUser,
                                auth: _vm.authenticated,
                                company: _vm.company,
                              },
                              on: { openSidebar: _vm.openSidebar },
                            })
                          : _vm._e(),
                        _c("Breadcrumbs", {
                          class: [
                            _vm.containerClasses,
                            // { 'custom-breadcrumbs-title': isManagersPage || isResourcesPage || isProjectPage},
                            // { 'custom-breadcrumbs-title':},
                          ],
                          attrs: { currentUser: _vm.currentUser },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "ContentScrollManager",
                      {
                        staticClass:
                          "flex-1 relative z-0 overflow-y-auto bg-secondary-background smooth-scroll",
                        attrs: { id: "content-scroll-manager" },
                      },
                      [
                        _c(
                          "main",
                          {
                            staticClass:
                              "focus:outline-none bg-secondary-background h-full",
                            attrs: { tabindex: "0" },
                          },
                          [
                            _vm.currentUser
                              ? _c("router-view", {
                                  staticClass: "w-full",
                                  class: _vm.innerLayoutClasses,
                                  attrs: {
                                    currentUser: _vm.currentUser,
                                    auth: _vm.authenticated,
                                    companyId: _vm.companyId,
                                    company: _vm.company,
                                  },
                                  on: {
                                    refetch: function ($event) {
                                      return _vm.$emit("refetch")
                                    },
                                    signOut: function ($event) {
                                      return _vm.$emit("signOut")
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c("PortalTarget", { attrs: { name: "modal" } }),
      _c("PortalTarget", { attrs: { name: "modal-lv2" } }),
      _c("PortalTarget", { attrs: { name: "time-tracker-modal" } }),
      _c("PortalTarget", { attrs: { name: "clock-in-modal" } }),
      _c("PortalTarget", { attrs: { name: "notes-modal" } }),
      _c("PortalTarget", { attrs: { name: "modal-lv3" } }),
      _vm.isSubscriptionInfoModalShown
        ? _c("SubscriptionBasicInfoModal", {
            attrs: { company: _vm.company, currentUser: _vm.currentUser },
            on: { close: _vm.hideSubscriptionInfo },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }